define("appkit/controllers/group-by", 
  ["appkit/utils/group-by","exports"],
  function(__dependency1__, __exports__) {
    "use strict";
    var groupBy = __dependency1__["default"];

    __exports__["default"] = Ember.ArrayController.extend({
      grouped: groupBy('type')
    });
  });